<template>
  <div class="customer-service-confirmation">
    <h1 class="main-title">{{ displayData.title }}</h1>
    <div class="content-body">
      <p v-for="(line, index) in contentLines" :key="index" class="content-line">
        {{ line }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerServiceConfirmation',
  props: {
    data: {
      type: Object,
      required: true,
      /**
       * 預期格式：
       * {
       *   title: string,   // 頁面標題，對應 API 2.2 notAvailableTitle
       *   content: string  // 說明文字，對應 API 2.2 notAvailableContent
       * }
       */
    }
  },
  computed: {
    sourceType() {
      return this.$store.getters['web/tongxin/sourceType'] || 'health'
    },
    displayData() {
      if (this.data && this.data.title && this.data.content) {
        return this.data;
      }
      const isVaccine = this.sourceType === 'vaccine'
      const isOutpatient = this.sourceType === 'outpatient'
      // 預設 Fallback
      return {
        title: isVaccine ? '疫苗掛號例外說明' : (isOutpatient ? '門診掛號例外說明' : '體檢 / 健檢掛號例外說明'),
        content: isVaccine
          ? '因您的疫苗預約需由診所進一步確認，所以目前無法直接讓您選擇時段。\n\n請先於下一頁選擇需要掛號的人員，診所人員將在後續協助您確認時段。'
          : (isOutpatient
            ? '因您的門診預約需由診所進一步確認，所以目前無法直接讓您選擇時段。\n\n請先於下一頁選擇需要掛號的人員，診所人員將在後續協助您確認時段。'
            : '因您的健檢含特殊項目，檢查需要排時間（例：大腸鏡）且可能有檢查前注意事項，所以無法直接讓您選擇時段。\n\n請先於下一頁選擇需要掛號的人員，診所人員將在後續協助您確認時段。')
      };
    },
    contentLines() {
      if (!this.displayData || !this.displayData.content) return []
      return this.displayData.content.split('\n').filter(line => line.trim().length > 0)
    }
  }
}
</script>

<style scoped>
.customer-service-confirmation {
  padding: 8px 0;
}

.main-title {
  font-size: 22px;
  font-weight: bold;
  color: #184a45;
  margin-bottom: 20px;
  line-height: 1.4;
}

.content-body {
  background-color: #f5f7f8;
  border-left: 6px solid #1f9c7b;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.content-line {
  font-size: 15px;
  color: #444;
  line-height: 1.8;
  margin: 0;
}
</style>
